function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#596168",
  fillRule: "evenodd",
  d: "M2.73 3.976a5.25 5.25 0 007.321 7.321l-7.322-7.32zM3.966 2.74l7.321 7.321A5.25 5.25 0 003.967 2.74zM7 14A7 7 0 117 0a7 7 0 010 14z"
});

var SvgClear = function SvgClear(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14"
  }, props), _ref);
};

export default SvgClear;